export const CALL_INSUFFICENT_NOTES_OUTCOMES = [
  'engaged',
  'answered',
  'another-person',
  'other',
];

export const VISIT_INSUFFICIENT_NOTES_OUTCOMES = [
  'engaged',
  'answered',
  'another-person',
  'wrong-address',
  'inaccessible',
  'other',
];

export const BLOCKED_CONTACT_MEMBER_STATUSES = ['misconduct'];

export const DEFAULT_TIMEZONE = 'America/Chicago';

/** `guides.guide_targets.targetTypeKey` for monthly new-engagement targets (warehouse-aligned). */
export const GUIDE_TARGET_TYPE_KEY_NEW_ENGAGEMENT = 'new_engagement';
export const TIMEZONE_OPTIONS = [
  'America/New_York',
  'America/Chicago',
  'America/Denver',
  'America/Los_Angeles',
  'America/Honolulu',
];
export const OFFSET_HOURS = 12;
export const DEFAULT_NOTES_PLACEHOLDER = 'Begin your note...';
export const RESOURCING_NOTES_PLACEHOLDER =
  '· Resource contact:\n· Encounter notes:';

export const CONSENT_TO_TREAT_KEY = 'treat';
export const CONSENT_TCPA_KEY = 'tcpa';
export const CONSENT_PHI_KEY = 'sms';
